import { createClient } from '@supabase/supabase-js';

// Reads credentials from the environment (frontend/.env). See .env.example.
const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Only construct a client when both values are present, so the app runs
// (and the waitlist form degrades gracefully) even before Supabase is wired up.
export const supabase = url && anonKey ? createClient(url, anonKey) : null;

// True once the two env vars are set. The waitlist form uses this to decide
// whether to submit for real or show a "not connected yet" message.
export const isSupabaseConfigured = Boolean(supabase);

// Table the waitlist writes to. Override with REACT_APP_WAITLIST_TABLE if needed.
export const WAITLIST_TABLE = process.env.REACT_APP_WAITLIST_TABLE || 'waitlist';
